import { render, staticRenderFns } from "./ServicesTotal.vue?vue&type=template&id=051a3e64&scoped=true&"
import script from "./ServicesTotal.vue?vue&type=script&lang=js&"
export * from "./ServicesTotal.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTotal.vue?vue&type=style&index=0&id=051a3e64&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a3e64",
  null
  
)

export default component.exports